import React from 'react'
import { useHistory } from 'react-router-dom'
import greeting from '../resources/img/wooCommece_inventory.png'


export default function Welcome({ wcInventoryConf, setWcInventoryConf }) {
    const history = useHistory()

    const enableAuthoRizationPage = () => {
        const tmpWcInventoryConf = { ...wcInventoryConf }
        tmpWcInventoryConf.enableAuthorizationPage = true
        setWcInventoryConf(tmpWcInventoryConf)
        history.push('/')
    }

    return (
        <div className="btcd-greeting">
            <img src={greeting} alt="" />
            <h2>Welcome to Inventory Connector for Zoho and WooCommerce</h2>
            <div className="sub">
                You can easily send data Woocommerce to Zoho Inventory. Ensure that this plugin makes your life easier.
            </div>
            <div className="initial-button flx flx-center">
                <button className="btn round btcd-btn-lg dp-blue" onClick={enableAuthoRizationPage}>
                    Create Integration
                </button>

                {/* <button className="btn round btcd-btn-lg dp-green" onClick={enableAuthoRizationPage}>
                    Get Pro
                </button> */}
            </div>
        </div>
    )
}
